export default __webpack_public_path__ + "static/media/donut-09.b08b151c.png";